import { Model } from "./model";
import { Box } from "./box";

export class BoxInterface extends Model {

  name?: string;

  description?: string;

  boxes?: Box[];

}
